import { z } from "zod";
import { UserDTOSchema, EmailSchema, SchoolNameSchema, ClassNameSchema } from "./auth";
import {LevelProgressDTOSchema} from "./progress";
import {AttemptDTOSchema} from "./attempts";

/**
 * `users` domain DTOs beyond `/me` (Master Spec §33/§34, Phase 11).
 * Split from `auth.ts` — `UserDTOSchema` itself is an auth-domain
 * concept (what `AuthResponseSchema` embeds), while this file is
 * specifically the admin-facing list view built on top of it.
 */
export const ListUsersResponseSchema = z.object({
  users: z.array(UserDTOSchema),
});
export type ListUsersResponse = z.infer<typeof ListUsersResponseSchema>;

export const UpdateProfileRequestSchema=z.object({displayName:z.string().trim().min(1).max(80)}).strict();
export type UpdateProfileRequest=z.infer<typeof UpdateProfileRequestSchema>;

export const UserSettingsSchema=z.object({soundEnabled:z.boolean(),volume:z.number().min(0).max(1),graphics:z.enum(['standard','performance']),autoTutorial:z.boolean()}).strict();
export type UserSettings=z.infer<typeof UserSettingsSchema>;
export const SettingsResponseSchema=z.object({settings:UserSettingsSchema.nullable(),revision:z.number().int().nonnegative()});
export const SaveSettingsRequestSchema=z.object({settings:UserSettingsSchema,baseRevision:z.number().int().nonnegative()}).strict();

export const AdminStudentEmailRequestSchema = z.object({
  newEmail: EmailSchema,
  expectedEmail: EmailSchema,
  reason: z.string().trim().min(5).max(500),
}).strict();
export const AdminStudentSchoolRequestSchema = z.object({schoolName: SchoolNameSchema, className: ClassNameSchema}).strict();
export const AdminStudentProgressResponseSchema = z.object({
  user: UserDTOSchema,
  progress: z.array(LevelProgressDTOSchema),
  attempts: z.array(AttemptDTOSchema),
});
export const AdminStudentsResponseSchema = z.object({students:z.array(UserDTOSchema.extend({
  completedLevels:z.number().int().nonnegative(), stars:z.number().int().nonnegative(),
  attemptsCount:z.number().int().nonnegative(), lastPlayedAt:z.string().datetime().nullable(),
}))});
export type AdminStudentsResponse = z.infer<typeof AdminStudentsResponseSchema>;
export type AdminStudentProgressResponse = z.infer<typeof AdminStudentProgressResponseSchema>;
